import { create } from 'zustand';

const useCityStore = create(set => ({
    citySettings: [],
    pathnamelist: [],
    apiurl: '',
    email: '',
    region: '',
    Latitude: '',
    Longitude: '',
    permission: null,
    setCitySettings: (settings) => set({ citySettings: settings }),
    setPathnamelist: (paths) => set({ pathnamelist: paths }),
    setApiurl: (apiurl) => set({ apiurl }),
    setEmail: (email) => set({ email }),
    setRegion: (region) => set({ region }),
    setLatitude: (Latitude) => set({ Latitude }),
    setLongitude: (Longitude) => set({ Longitude }),
    setPermission: (permission) => set({ permission })
}));

export default useCityStore;